import z from 'zod';
const STRIPE_TAX_RATE_ID_PREFIX = 'txr_';
export const stripeTaxRateIdValue = z
    .string()
    .trim()
    .refine(isValidStripeTaxRateIdFormat, {
    message: 'Invalid stripe tax rate id format',
})
    .brand('StripeTaxRateId');
export const createStripeTaxRateId = (value) => stripeTaxRateIdValue.parse(value);
export const isStripeTaxRateId = (value) => stripeTaxRateIdValue.safeParse(value).success;
export function isValidStripeTaxRateIdFormat(value) {
    const normalizedValue = value.trim();
    return normalizedValue.startsWith(STRIPE_TAX_RATE_ID_PREFIX)
        && normalizedValue.length > STRIPE_TAX_RATE_ID_PREFIX.length;
}
//# sourceMappingURL=stripe-tax-rate-id.js.map